import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.')
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    // Configure session persistence
    storage: window.localStorage,
    storageKey: 'sb-auth-token',
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  // Add global configuration
  global: {
    headers: {
      'x-client-info': 'quill-ai@1.0.0',
    },
  },
})

// Auth helper functions
export const getCurrentUser = () => {
  return supabase.auth.getUser()
}

export const signOut = async () => {
  try {
    // Clear any potentially corrupted session data
    const { error } = await supabase.auth.signOut()
    if (error) {
      console.warn('Sign out error:', error)
      // Force clear local storage if sign out fails
      localStorage.removeItem('sb-auth-token')
    }
    return { error }
  } catch (err) {
    console.error('Force sign out error:', err)
    // Force clear local storage
    localStorage.removeItem('sb-auth-token')
    return { error: err }
  }
}

export const signInWithPassword = (email, password) => {
  return supabase.auth.signInWithPassword({ email, password })
}

export const signUp = (email, password, userData) => {
  return supabase.auth.signUp({ 
    email, 
    password,
    options: {
      data: userData
    }
  })
} 

// Session debugging helpers
export const getStoredSession = () => {
  try {
    const stored = localStorage.getItem('sb-auth-token')
    return stored ? JSON.parse(stored) : null
  } catch (error) {
    console.error('Error reading stored session:', error)
    return null
  }
}

export const clearStoredSession = () => {
  try {
    localStorage.removeItem('sb-auth-token')

  } catch (error) {
    console.error('Error clearing stored session:', error)
  }
} 